export default class Rating {
  constructor(obj) {

    this.rating = obj.rating;
    this.ratingType = obj.ratingType;
    this.rateableId = obj.rateableId;
    this.rateableType = obj.rateableType;

    this.key = `${this.rateableType}-${this.rateableId}`;

  }

  hasRating() {
    return typeof this.rating === 'number';
  }

  static enabled(store, rateableType) {
    const pv = store.getters['productVars/get']['ratingConfig'];
    if (pv?.value) {
      const value = JSON.parse(pv.value);
      return Object.keys(value).includes(rateableType);
    }
  }
}
